<template>
  <div>
    <Table :no-data-text="$t('common.noData')" :columns="columns" :data="lifecycleResourcesDate" style="width: 100.1%;">
      <template slot-scope="{row,index}" slot="detail">
        <Button type="info" size="small" @click="resourceDetail(row)">{{$t('resourceLifecycle.view')}}</Button>
        <div v-if="row.state==4">
          <Button type="info" size="small" @click="changeResource(row)">{{$t('resourceLifecycle.change')}}</Button>
          <Button type="info" size="small" @click="renewal(row)">{{$t('resourceLifecycle.renew')}}</Button>
          <Button type="info" size="small" @click="recycle(row)">{{$t('resourceLifecycle.recycle')}}</Button>
        </div>
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage"
          @on-page-size-change="changeSize" :transfer="true"></Page>
  </div>
</template>
<script>
  var tableResourceServiceDirectoryVue = {};
  export default {
    name: 'TableResourceServiceDirectory',
    data() {
      return {
        usageNote: '',
        resourceName: '',
        resourceType: '',
        current: 1,
        dataTotal: 0,
        pageSize: 10,
        columns: [
          {
            title: this.$t("resourceLifecycle.use"),
            key: 'usageNote'
          },
          {
            title: this.$t("resourceLifecycle.platform"),
            key: 'platformString'
          },
          {
            title: this.$t("resourceLifecycle.region"),
            key: 'region'
          },
          {
            title: this.$t("resourceLifecycle.resourceName"),
            key: 'lifecycleResourceName'
          },
          {
            title: this.$t("resourceLifecycle.resourceType"),
            key: 'lifecycleResourceTypeDesc'
          },
          {
            title: this.$t("resourceLifecycle.resourceState"),
            key: 'stateDesc'
          },
          {
            title: this.$t("resourceLifecycle.environment"),
            key: 'environmentDesc'
          },
          {
            title: this.$t("resourceLifecycle.term"),
            key: 'duration'
          },
          {
            title: this.$t("resourceLifecycle.startDate"),
            key: 'startDateStr'
          },
          {
            title: this.$t("resourceLifecycle.endDate"),
            key: 'endDateStr'
          },
          {
            title: this.$t("resourceLifecycle.estimatedCost"),
            key: 'cost'
          },
          {
            title: this.$t('common.operation'),
            slot: 'detail',
            width: 210
          }],
        lifecycleResourcesDate: []
      }
    },
    beforeCreate: function () {
      tableResourceServiceDirectoryVue = this
    },
    mounted: function () {
      tableResourceServiceDirectoryVue.getData();
    },
    methods: {
      showAll: function () {
        tableResourceServiceDirectoryVue.getData();
      },
      // 分页显示数据
      /****************************************************/
      getData: function () {
        //获取ResourceServiceDirectorySearch里面的搜索内容
        eventBus.$on('usageNote', function (val) {
          tableResourceServiceDirectoryVue.usageNote = val;
        })
        eventBus.$on('resourceName', function (val) {
          tableResourceServiceDirectoryVue.resourceName = val;
        })
        eventBus.$on('resourceType', function (val) {
          tableResourceServiceDirectoryVue.resourceType = val;
        })

        var pageResourceServiceDirectoryDate = {
          "pageNum": this.current,
          "pageSize": this.pageSize,
          "usageNote": tableResourceServiceDirectoryVue.usageNote,
          "lifecycleResourceName": tableResourceServiceDirectoryVue.resourceName,
          "lifecycleResourceType": tableResourceServiceDirectoryVue.resourceType
        };

        this.$api.lifecycleResourceApplication.listLifecycleResourceByPage(pageResourceServiceDirectoryDate)
          .then(res => {
            this.lifecycleResourcesDate = res.data.records;
            // 当前页
            this.current = res.data.current;
            // 总条数
            this.dataTotal = res.data.total;
          });
      },
      changePage: function (current) {
        this.current = current;
        tableResourceServiceDirectoryVue.getData();
      },
      changeSize: function (pageSize) {
        this.pageSize = pageSize;
        tableResourceServiceDirectoryVue.getData();
      },
      // 销毁caseSearchID
      beforeDestroy: function () {
        eventBus.$off('usageNote');
        eventBus.$off('resourceName');
        eventBus.$off('resourceType');
      },
      //详情
      resourceDetail: function (row) {
        this.$router.push({
          path: '/resourceLifecycleManagement/resourceDetail',
          query: {id: row.id, platform: row.platform, lifecycleResourceType: row.lifecycleResourceType,platformString:row.platformString,lifecycleResourceTypeDesc:row.lifecycleResourceTypeDesc}
        });
      },
      //变更
      changeResource: function (row) {
        this.$router.push({
          path: '/resourceLifecycleManagement/resourceChange',
          query: {id: row.id, platform: row.platform, lifecycleResourceType: row.lifecycleResourceType,platformString:row.platformString,lifecycleResourceTypeDesc:row.lifecycleResourceTypeDesc,t: Date.now()}
        });
      },
      //续约
      renewal: function (row) {
        this.$router.push({
          path: '/resourceLifecycleManagement/resourceRenewal',
          query: {id: row.id, platform: row.platform, lifecycleResourceType: row.lifecycleResourceType,platformString:row.platformString,lifecycleResourceTypeDesc:row.lifecycleResourceTypeDesc,t: Date.now()}
        });
      },
      //回收
      recycle: function (row) {
        this.$router.push({
          path: '/resourceLifecycleManagement/resourceRecycle',
          query: {id: row.id, platform: row.platform, lifecycleResourceType: row.lifecycleResourceType,platformString:row.platformString,lifecycleResourceTypeDesc:row.lifecycleResourceTypeDesc,t: Date.now()}
        });
      }
    }
  }
</script>
<style>
  .ivu-page {
    margin-top: 10px !important;
    margin-bottom: 30px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_service_directory/TableResourceServiceDirectory.vue